module.exports = __webpack_public_path__ + "img/home-largest-wallet.0eb5b3a7.png";